if ($(".csv_config_style")) {

    $(document).ready(function () {

        $("#ssl").change(function () {

            if ($("#ssl").prop('checked')) {
                $(".ssl_form").removeClass("d-none");

            } else {
                $(".ssl_form").addClass("d-none");
            }
        });

        $("#has_header").change(function () {

            if ($("#has_header").prop('checked')) {
                $(".header_form").removeClass("d-none");


            } else {
                $(".header_form").addClass("d-none");
            }
        });

        $("#active").change(function () {

            if ($("#active").prop('checked')) {
                $(".csv_config").removeClass("d-none");

            } else {

                $(".csv_config").addClass("d-none");

            }
        });

        $("#has_config").change(function () {

            if ($("#has_config").prop('checked')) {
                $(".csv_form").removeClass("d-none");

            } else {

                $(".csv_form").addClass("d-none");

            }
        });
        $("#has_position").change(function () {

            if ($("#has_position").prop('checked')) {
                $(".position_form").removeClass("d-none");


            } else {
                $(".position_form").addClass("d-none");
            }
        });

        if ($(".csv_edit")) {
            if ($("#active").prop('checked')) {

                $("#active").removeClass("d-none");
                if ($("#has_header").prop('checked')) {
                    $(".header_form").removeClass("d-none");
                }

                $(".csv_config").removeClass("d-none");
                if ($("#has_config").prop('checked')) {
                    $(".csv_form").removeClass("d-none");
                }

                if ($("#ssl").prop('checked')) {
                    $(".ssl_form").removeClass("d-none");
                }

                if ($("#has_position").prop('checked')) {
                    $(".position_form").removeClass("d-none");
                }

            }
        }
    });
}